"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.MessageClient"));

var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));

var _encUtf = _interopRequireDefault(require("crypto-js/enc-utf8"));

var _amb2 = _interopRequireDefault(require("./amb.Logger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

'use strict';

var LOGGER = new _amb2.default('amb.MessageClientBuilder');
/**
 * @param {string} baseURL - optional URL of the ServiceNow instance for the AMB Client on a third-party page
 */

var getClient = function getClient() {
  var baseURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var client = getParentAmbClient(window);

  if (!client) {
    /* IE11 has an instance of the amb client for each iframe. This check ensures that there is only one login popup
    per page by turning off the login popup for clients inside an iframe.
    */
    var dontShowLogin = isIE11(window) && window.frameElement !== null;
    if (!baseURL) baseURL = window.location.protocol + '//' + window.location.host;
    client = wrapClient(buildClient(dontShowLogin, baseURL), window); // set it for reuse

    setClient(client);
  } else if (baseURL && baseURL !== client.getBaseURL()) {
    LOGGER.addErrorMessage('Client already set up to connect to ' + client.getBaseURL());
    throw new Error('Client already set up to connect to ' + client.getBaseURL());
  }

  return wrapClient(client, window);
};

function getParentAmbClient(clientWindow) {
  // PRB682487 try/catch in case parent is accessed from an iframe
  try {
    // try to find an existing client
    // PRB713556 do not walk up to the parent window for IE11 as it causes a memory leak.
    if (!isIE11(clientWindow)) {
      while (clientWindow !== clientWindow.parent) {
        if (clientWindow.g_ambClient) {
          break;
        }

        clientWindow = clientWindow.parent;
      }
    }

    if (clientWindow.g_ambClient) {
      return clientWindow.g_ambClient;
    }
  } catch (e) {
    console.log('AMB getClient() tried to access parent from an iFrame. Caught error: ' + e);
  }

  return null;
}

function isIE11(window) {
  return window.MSInputMethodContext && window.document.documentMode;
}
/**
 * Enforces the calling window context for event subscription cleanup
 * @param {AMBClient} client
 * @param {Window} clientWindow
 */


function wrapClient(client, clientWindow) {
  if (typeof client.getClientWindow !== 'undefined') {
    var context = client.getClientWindow(); // we don't need to wrap the client

    if (context === clientWindow) {
      return client;
    }
  }

  var wrappedClient = clone({}, client);

  wrappedClient.getChannel = function (channelName, subscriptionConfig, overrideWindow) {
    return client.getChannel(channelName, subscriptionConfig, overrideWindow || clientWindow);
  };

  wrappedClient.getRecordWatcherChannel = function (table, query, actionPrefix, subscriptionConfig, overrideWindow) {
    return client.getRecordWatcherChannel(table, query, actionPrefix, subscriptionConfig, overrideWindow || clientWindow);
  };

  wrappedClient.subscribeToEvent = function (event, callback, overrideWindow) {
    return client.subscribeToEvent(event, callback, overrideWindow || clientWindow);
  };

  wrappedClient.unsubscribeFromEvent = function (id, overrideWindow) {
    return client.unsubscribeFromEvent(id, overrideWindow || clientWindow);
  };

  wrappedClient.getClientWindow = function () {
    return clientWindow;
  };

  return wrappedClient;
}
/**
 * Shallow object clone
 * @param {Object} dest
 * @param {Object} source
 * @return {Object}
 */


function clone(dest, source) {
  for (var prop in source) {
    if (Object.prototype.hasOwnProperty.call(source, prop)) dest[prop] = source[prop];
  }

  return dest;
}

function setClient(client) {
  var _window = window.self;
  _window.g_ambClient = client; // disconnect when the client is unloaded

  _window.addEventListener("unload", function () {
    _window.g_ambClient.disconnect();
  });

  var defaultAmbConnectionTimeout = 10000;
  var shouldDeferAmbConnection = _window.NOW && _window.NOW.hasOwnProperty('deferAmbConnection') ? _window.NOW.deferAmbConnection : false;
  var deferredAmbConnectionTimeout = _window.NOW && _window.NOW.hasOwnProperty('deferredAmbConnectionTimeout') && isValidAmbConnectionTimeout(_window.NOW.deferredAmbConnectionTimeout) ? _window.NOW.deferredAmbConnectionTimeout : defaultAmbConnectionTimeout;

  if (shouldDeferAmbConnection) {
    _window.setTimeout(autoConnect, deferredAmbConnectionTimeout);
  } else {
    // auto-connect on load or timeout
    var documentReadyState = _window.document ? _window.document.readyState : null;
    if (documentReadyState === 'complete') autoConnect();else _window.addEventListener('load', autoConnect);

    _window.setTimeout(autoConnect, defaultAmbConnectionTimeout);
  }

  var initiatedConnection = false;

  function autoConnect() {
    if (!initiatedConnection) {
      initiatedConnection = true;

      _window.g_ambClient.connect();
    }
  }

  function isInteger(num) {
    return parseInt(num, 10) === num;
  }

  function isValidAmbConnectionTimeout(timeout) {
    return isInteger(timeout) && timeout > 0;
  }
}

function buildClient(dontShowLogin, baseURL) {
  return function () {
    var ambClient = new _amb.default(baseURL);
    var clientSubscriptions = buildClientSubscriptions();
    var serverConnection = ambClient.getServerConnection();

    if (dontShowLogin) {
      serverConnection.setLoginWindowEnabled(false);
    }

    return {
      getServerConnection: function getServerConnection() {
        return serverConnection;
      },
      connect:
      /*void*/
      function connect() {
        ambClient.connect();
      },
      abort:
      /*void*/
      function abort() {
        ambClient.abort();
      },
      disconnect:
      /*void*/
      function disconnect() {
        ambClient.disconnect();
      },
      getConnectionState:
      /*String*/
      function getConnectionState() {
        return ambClient.getConnectionState();
      },
      getState:
      /*String*/
      function getState() {
        return ambClient.getConnectionState();
      },

      /**
       * Cancel transaction
       * @param cancelRequests: array of requests, which in the format: [{"nowUIInteraction": "interaction_2", "callback":function(message) { console.log(message);}}, {"nowUIInteraction": "interaction_3", "callback":function(message) { console.log(message);}}];
       */
      cancelTransaction:
      /*void*/
      function cancelTransaction(cancelRequests) {
        ambClient.cancelTransaction(cancelRequests);
      },
      getClientId:
      /*String*/
      function getClientId() {
        return ambClient.getClientId();
      },
      getChannel:
      /*amb.ChannelListener*/
      function getChannel(channelName, subscriptionConfig, windowContext) {
        var channel = ambClient.getChannel(channelName, subscriptionConfig);
        var originalSubscribe = channel.subscribe;
        var originalUnsubscribe = channel.unsubscribe;
        windowContext = windowContext || window;

        channel.subscribe = function (listener) {
          clientSubscriptions.add(windowContext, channel, listener, function () {
            channel.unsubscribe(listener);
          });
          originalSubscribe.call(channel, listener);
          return channel;
        };

        channel.unsubscribe = function (listener) {
          clientSubscriptions.remove(windowContext, channel, listener);
          var call = originalUnsubscribe.call(channel, listener);

          if (serverConnection.getChannel(channelName).getChannelListeners().length === 0) {
            ambClient.removeChannel(channelName);
          }

          return call;
        };

        return channel;
      },
      getChannel0:
      /*amb.ChannelListener*/
      function getChannel0(
      /*String*/
      channelName,
      /*Function*/
      subscriptionCallback) {
        return ambClient.getChannel(channelName, subscriptionCallback);
      },

      /**
       * Creates a channel with a properly encoded name required for Record Watcher. Returns a channel listener.
       *
       * @param {string} table
       * @param {string} query
       * @param {string} actionPrefix
       * @param {Object<*>} subscriptionConfig
       * @param {Object<*>} windowContext
       * @returns {*|amb.ChannelListener}
       */
      getRecordWatcherChannel: function getRecordWatcherChannel(table, query, actionPrefix, subscriptionConfig, windowContext) {
        // replace base64 padding character due to '=' is invalid channel name
        var base64EncodedQuery = _encBase.default.stringify(_encUtf.default.parse(query)).replace(/=/g, '-');

        actionPrefix = actionPrefix || 'default';
        return this.getChannel('/rw/' + actionPrefix + '/' + table + '/' + base64EncodedQuery, subscriptionConfig, windowContext);
      },
      registerExtension:
      /*void*/
      function registerExtension(
      /*String*/
      extensionName,
      /*Object*/
      extension) {
        ambClient.registerExtension(extensionName, extension);
      },
      unregisterExtension:
      /*void*/
      function unregisterExtension(
      /*String*/
      extensionName) {
        ambClient.unregisterExtension(extensionName);
      },
      batch:
      /*void*/
      function batch(
      /*function(){...}*/
      block) {
        ambClient.batch(block);
      },
      subscribeToEvent:
      /*Number*/
      function subscribeToEvent(
      /*String*/
      event,
      /*Function*/
      callback,
      /*Object*/
      windowContext) {
        windowContext = windowContext || window;
        var id = ambClient.subscribeToEvent(event, callback);
        clientSubscriptions.add(windowContext, id, true, function () {
          ambClient.unsubscribeFromEvent(id);
        });
        return id;
      },
      unsubscribeFromEvent:
      /*void*/
      function unsubscribeFromEvent(
      /*Number*/
      id,
      /*Object*/
      windowContext) {
        windowContext = windowContext || window;
        clientSubscriptions.remove(windowContext, id, true);
        ambClient.unsubscribeFromEvent(id);
      },
      isLoggedIn:
      /*boolean*/
      function isLoggedIn() {
        return ambClient.isLoggedIn();
      },
      getConnectionEvents:
      /*Hash*/
      function getConnectionEvents() {
        return ambClient.getConnectionEvents();
      },
      getEvents:
      /*Hash*/
      function getEvents() {
        return ambClient.getConnectionEvents();
      },
      reestablishSession: function reestablishSession() {
        ambClient.reestablishSession();
      },
      loginComplete: function loginComplete() {
        ambClient.loginComplete();
      },
      getChannels: function getChannels() {
        return ambClient.getChannels();
      },
      extendSession: function extendSession() {
        return ambClient.extendSession();
      },
      getTokenManagementExtension: function getTokenManagementExtension() {
        return ambClient.getTokenManagementExtension();
      },
      // For unit testing
      getBaseURL: function getBaseURL() {
        return baseURL;
      }
    };
  }();

  function buildClientSubscriptions() {
    var contexts = [];

    function addSubscription(clientWindow, id, callback, unsubscribe) {
      if (!clientWindow || !callback || !unsubscribe) return;
      removeSubscription(clientWindow, id, callback);
      var context = getContext(clientWindow);

      if (!context) {
        context = createContext(clientWindow);
      }

      if (context.unloading) return;
      context.subscriptions.push({
        id: id,
        callback: callback,
        unsubscribe: unsubscribe
      });
    }

    function removeSubscription(clientWindow, id, callback) {
      if (!clientWindow || !callback) return;
      var context = getContext(clientWindow);
      if (!context) return;
      var subscriptions = context.subscriptions;

      for (var i = subscriptions.length - 1; i >= 0; i--) {
        if (subscriptions[i].id === id && subscriptions[i].callback === callback) subscriptions.splice(i, 1);
      }
    }

    function getContext(clientWindow) {
      for (var i = 0, iM = contexts.length; i < iM; i++) {
        if (contexts[i].window === clientWindow) return contexts[i];
      }

      return null;
    }

    function createContext(clientWindow) {
      var context = {
        window: clientWindow,
        onUnload: function onUnload() {
          context.unloading = true;
          var subscriptions = context.subscriptions;
          var subscription;

          while (subscription = subscriptions.pop()) {
            subscription.unsubscribe();
          }

          destroyContext(context);
        },
        unloading: false,
        subscriptions: []
      };
      clientWindow.addEventListener('unload', context.onUnload);
      contexts.push(context);
      return context;
    }

    function destroyContext(context) {
      for (var i = 0, iM = contexts.length; i < iM; i++) {
        if (contexts[i].window === context.window) {
          contexts.splice(i, 1);
          break;
        }
      }

      context.subscriptions = [];
      context.window.removeEventListener('unload', context.onUnload);
      context.onUnload = null;
      context.window = null;
    }

    return {
      add: addSubscription,
      remove: removeSubscription
    };
  }
}

var _default = getClient;
exports.default = _default;